import { Typography } from "@material-ui/core";
import React from "react";

interface Props {
  titulo: string;
}

interface State {
  falhou: boolean;
}

class LimiteErroTela extends React.Component<Props, State> {
  state: State = { falhou: false };

  static getDerivedStateFromError(): State {
    return { falhou: true };
  }

  componentDidCatch(erro: Error) {
    console.error(erro);
  }

  render() {
    if (this.state.falhou) {
      return (
        <div style={{ padding: 24, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            Não foi possível abrir "{this.props.titulo}".
          </Typography>
          <Typography color="textSecondary">
            Esta tela está indisponível no momento. Entre em contato com o suporte.
          </Typography>
        </div>
      );
    }
    return this.props.children;
  }
}

export default LimiteErroTela;
